import React, { useContext } from 'react';
import { Context } from '../../context/news_search.context';
import styles from './applied_saved_search.module.scss';

const AppliedSavedSearch: React.FC = () => {
  const { appliedSavedSearch, clearAllFilters } = useContext(Context);

  if (!Object.keys(appliedSavedSearch).length) return null;

  return (
    <div className='container'>
      <div className={`row pb-25 mb-4 ${styles.closeSearch}`}>
        <div className='col-xs-12 col-md-9 '>
          <h2 className={`py-1 ${styles.closeSearchTitle}`}>
            <span className='text-gray-li'>Results for</span> {appliedSavedSearch.title}
          </h2>
        </div>
        <div className='col-xs-12 col-md-3 pt-2 mb-15 mb-md-0'>
          <button onClick={clearAllFilters} className='btn btn-outline-secondary w-100'>
            <i className='fal icon-times pe-15' />
            <span className='ms-15 input-button'>Close alert</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default AppliedSavedSearch;
